import { Injectable } from '@angular/core';
import { EquipmentType, PagedResult, Segment } from '@core/interfaces';
import { Apollo } from 'apollo-angular';
import gql from 'graphql-tag';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class EquipmentsTypesApi {
  constructor(private readonly apollo: Apollo) { }

  listEquipmentsTypes({ where, orderBy, limit, offset }): Observable<PagedResult<EquipmentType>> {
    return this.apollo
      .query({
        query: gql`
          query equipmentsTypes($where: EquipmentTypeWhereInput, $orderBy: EquipmentTypeOrderByInput, $limit: Int, $offset: Int) {
            equipmentsTypes(where: $where, orderBy: $orderBy, limit: $limit, offset: $offset) {
              totalCount
              items {
                id
                name
                createdAt
                archived
              }
            }
          }
        `,
        variables: {
          where,
          orderBy,
          limit,
          offset
        }
      })
      .pipe(map((response) => response.data['equipmentsTypes'] as PagedResult<EquipmentType>));
  }

  listAllSegments(where): Observable<Segment[]> {
    return this.apollo
      .query({
        query: gql`
          query listSegments($where: SegmentWhereInput) {
            segments(where: $where, orderBy: name_asc, limit: 100, offset: 0) {
              items {
                id
                name
                archived
              }
            }
          }
        `,
        variables: {
          where
        }
      })
      .pipe(map((response) => response.data['segments']['items'] as Segment[]));
  }

  getEquipmentTypeById(id: string): Observable<EquipmentType | null> {
    return this.apollo
      .query({
        query: gql`
          query getEquipmentTypeById($id: ID!) {
            equipmentType(id: $id) {
              id
              name
              createdAt
              archived
              segment {
                id
                name
                archived
              },
              customFields {
                id
                name
                type
                required
                position
                options {
                  value
                  position
                }
              }
              equipmentTypeForms {
                form {
                  id
                  name
                  archived
                }
                maintenanceType {
                  id
                  name
                  archived
                }
                requiredComplete
                requiredReport
              }
              preferences {
                featureAutoApproveEquipments
              }
            }
          }
        `,
        variables: {
          id
        }
      })
      .pipe(map((response) => response.data['equipmentType'] as EquipmentType));
  }

  updateEquipmentType(id: string, input: any): Observable<EquipmentType> {
    return this.apollo
      .query({
        query: gql`
          mutation updateEquipmentType($id: ID!, $input: EquipmentTypeInput!) {
            updateEquipmentType(id: $id, input: $input) {
              id
            }
          }
        `,
        variables: {
          id,
          input
        }
      })
      .pipe(map((response) => response.data['updateEquipmentType']));
  }

  createEquipmentType(input: any): Observable<EquipmentType> {
    return this.apollo
      .query({
        query: gql`
          mutation createEquipmentType($input: EquipmentTypeInput!) {
            createEquipmentType(input: $input) {
              id
            }
          }
        `,
        variables: {
          input
        }
      })
      .pipe(map((response) => response.data['createEquipmentType']));
  }
}
